import Head from "next/head";
import { useRouter } from "next/router";
import { getImageUrl } from "../utils/helperFunction";

const Seo = ({ seo }) => {
  const { locale } = useRouter();
  const imageType = Object.prototype.toString.call(seo?.image);

  const DEFAULT_SEO_FA = {
    title: "شرکت پلیمر آریا ساسول .:. وب سایت رسمی :.",
    description: "شرکت پلیمر آریا ساسول تولید کننده اتیلن و پلی اتیلن",
  };
  const DEFAULT_SEO_EN = {
    title: "Aryasasol Polymer Company  .:. Official website .:.",
    description:
      "Arya Sasol Polymer Company as the producer of Ethylene and Polyethylene",
  };
  const SEO = {
    title: !!seo?.title
      ? seo.title
      : locale === "fa"
      ? DEFAULT_SEO_FA.title
      : DEFAULT_SEO_EN.title,
    description: !!seo?.description
      ? seo.description
      : locale === "fa"
      ? DEFAULT_SEO_FA.title
      : DEFAULT_SEO_EN.title,
    image:
      imageType === "[object Object]"
        ? process.env.BASE_URL + getImageUrl(seo.image, "medium")?.url
        : imageType === "[object String]"
        ? seo.image
        : "/images/seo_image.jpg",
  };

  return (
    <Head>
      {SEO.title && (
        <>
          <title>{SEO.title}</title>
          <meta property="og:title" content={SEO.title} />
          <meta name="twitter:title" content={SEO.title} />
        </>
      )}
      {SEO.description && (
        <>
          <meta name="description" content={SEO.description} />
          <meta property="og:description" content={SEO.description} />
          <meta name="twitter:description" content={SEO.description} />
        </>
      )}
      {SEO.image && (
        <>
          <meta property="og:image" content={SEO.image} />
          <meta name="twitter:image" content={SEO.image} />
          <meta name="image" content={SEO.image} />
        </>
      )}
      {SEO.article && <meta property="og:type" content="article" />}
      <meta name="twitter:card" content="summary_large_image" />
    </Head>
  );
};

export default Seo;
